export const mapListToOptions = (items, prop) =>
  items.map((i) => {
    const value = prop ? i[prop] : i;
    return {
      title: value,
      value
    };
  });
